export default __webpack_public_path__ + "img/SuvlHZSS.3743456b.svg";